import { createSelector } from '@ngrx/store';
import { GlobalState } from './../store';

export const selectCertificate = (state: GlobalState) => state.certificate;
export const selectCertificateInfo = createSelector(
  selectCertificate,
  certificate => certificate?.certificateInfo
);

export const selectCertificateIssuer = createSelector(
  selectCertificate,
  certificate => certificate?.certificateInfo.issuerDN
);

export const selectCertificateSubject = createSelector(
  selectCertificate,
  certificate => certificate?.certificateInfo.subjectDN
);

export const selectCertificateSubjectDnMap = createSelector(
    selectCertificate,
    certificate => certificate?.certificateInfo.subjectDnMap
  );

//export const certificateSelector = createSelector<GlobalState, any, any>();
